import dewpoint from '../dewPoint';

/*
 * @param {t} : The temperature in °C
 * @param {h} : The air humidity in % (0 <= h <= 1)
 * @returns : the humidex in °C
 */
export default (t: number, h: number) => {
  const expIndex = 5417.753 * (1 / 273.16 - 1 / (dewpoint(t, h) + 273.16));
  return t + 0.5555 * (6.11 * Math.exp(expIndex) - 10);
};
